// particleOptions.ts

type ParticleOptions = {
    /* your particle options type */
};

export const lightParticleOptions: ParticleOptions =
{
    background: {
        color: {
            value: "#F8F0E5",
        }
    },
    fpsLimit: 144,
    interactivity: {
        events: {
            onClick: {
                enable: true,
                mode: "push",
            },
            onHover: {
                enable: true,
                mode: "repulse",
            },
            // resize: true,
        },
        modes: {
            push: {
                quantity: 0,
            },
            repulse: {
                distance: 100,
                duration: 1,
            },
        },
    },
    particles: {
        color: {
            value: "rgb(199, 165, 165)",
        },
        links: {
            color: "rgb(219, 144, 144)",
            distance: 150,
            enable: true,
            opacity: 0.1,
            width: 1,
        },
        collisions: {
            enable: true,
        },
        move: {
            direction: "none",
            enable: true,
            outModes: {
                default: "bounce",
            },
            random: false,
            speed: 0.2,
            straight: false,
        },
        number: {
            density: {
                enable: true,
                area: 1400,
            },
            value: 120,
        },
        opacity: {
            value: { min: 0.2, max: 0.4}
        },
        shape: {
            type: "circle",
        },
        size: {
            value: { min: 1, max: 5 },
        },
    },
    detectRetina: true,
};

export const darkParticleOptions: ParticleOptions =
{
    background: {
        color: {
            value: "#202027",
        }
    },
    fpsLimit: 144,
    interactivity: {
        events: {
            onClick: {
                enable: true,
                mode: "push",
            },
            onHover: {
                enable: true,
                mode: "repulse",
            },
            // resize: true,
        },
        modes: {
            push: {
                quantity: 0,
            },
            repulse: {
                distance: 100,
                duration: 1,
            },
        },
    },
    particles: {
        color: {
            value: "rgb(80, 123, 134)",
        },
        links: {
            color: "rgb(58, 77, 112)",
            distance: 150,
            enable: true,
            opacity: 0.2,
            width: 1,
        },
        collisions: {
            enable: true,
        },
        move: {
            direction: "none",
            enable: true,
            outModes: {
                default: "bounce",
            },
            random: false,
            speed: 0.2,
            straight: false,
        },
        number: {
            density: {
                enable: true,
                area: 1400,
            },
            value: 120,
        },
        opacity: {
            value: { min: 0.2, max: 0.4}
        },
        shape: {
            type: "triangle",
        },
        size: {
            value: { min: 1, max: 5 },
        },
    },
    detectRetina: true,
};